export default __webpack_public_path__ + "static/media/CarImages.RioGallery2.fd29cd19.jpg";